/* --- Inline Script --- */

            (function () {
                const isMatchingClass = (linkRule, href, classes) => {
                    return classes.includes(linkRule.value)
                }
                const isMatchingDomain = (linkRule, href, classes) => {
                    if(!URL.canParse(href)) {
                        return false
                    }

                    const url = new URL(href)

                    return linkRule.value === url.host
                }
                const isMatchingExtension = (linkRule, href, classes) => {
                    if(!URL.canParse(href)) {
                        return false
                    }

                    const url = new URL(href)

                    return url.pathname.endsWith('.' + linkRule.value)
                }
                const isMatchingSubdirectory = (linkRule, href, classes) => {
                    if(!URL.canParse(href)) {
                        return false
                    }

                    const url = new URL(href)

                    return url.pathname.startsWith('/' + linkRule.value + '/')
                }
                const isMatchingProtocol = (linkRule, href, classes) => {
                    if(!URL.canParse(href)) {
                        return false
                    }

                    const url = new URL(href)

                    return url.protocol === linkRule.value + ':'
                }
                const isMatch = (linkRule, href, classes) => {
                    switch (linkRule.type) {
                        case 'class':
                            return isMatchingClass(linkRule, href, classes)
                        case 'domain':
                            return isMatchingDomain(linkRule, href, classes)
                        case 'extension':
                            return isMatchingExtension(linkRule, href, classes)
                        case 'subdirectory':
                            return isMatchingSubdirectory(linkRule, href, classes)
                        case 'protocol':
                            return isMatchingProtocol(linkRule, href, classes)
                        default:
                            return false;
                    }
                }
                const track = (element) => {
                    const href = element.href ?? null
                    const classes = Array.from(element.classList)
                    const parentsToMatch = [
                        'li.menu-item', // Non-block menu item
                        'li.wp-block-navigation-item', // Block menu item
                        'div.wp-block-button', // Block button group
                    ]

                    // When a WordPress menu or button allows a user customizable class, the class is
                    // placed on a parent element instead of the button/a. If the parent matches one
                    // of these elements, then it's classes should also be considered.
                    if(parentsToMatch.some((toMatch) => element.parentElement.matches(toMatch))) {
                        classes.push(...Array.from(element.parentElement.classList))
                    }

                    const linkRules = [{"type":"class","value":"btn-atc"},{"type":"class","value":"btn-shop-now"},{"type":"extension","value":"pdf"},{"type":"extension","value":"zip"},{"type":"protocol","value":"mailto"},{"type":"protocol","value":"tel"}]
                    if(linkRules.length === 0) {
                        return
                    }

                    const hasMatch = linkRules.some((linkRule) => {
                        return isMatch(linkRule, href, classes)
                    })

                    if(!hasMatch) {
                        return
                    } else {
                        
                    }

                    const url = "https://boomn-dev.instawp.xyz/mva/wp-content/uploads/sites/3/iawp-click-endpoint.php";
                    const body = {
                        href: href,
                        classes: classes.join(' '),
                        ...{"payload":{"resource":"singular","singular_id":424,"page":1},"signature":"e4637746789665f6f955fcfda0dc8ca0"}                    };

                    if (navigator.sendBeacon) {
                        let blob = new Blob([JSON.stringify(body)], {
                            type: "application/json"
                        });
                        navigator.sendBeacon(url, blob);
                    } else {
                        const xhr = new XMLHttpRequest();
                        xhr.open("POST", url, true);
                        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
                        xhr.send(JSON.stringify(body))
                    }
                }
                document.addEventListener('mousedown', function (event) {
                                        if (navigator.webdriver || /bot|crawler|spider|crawling|semrushbot|chrome-lighthouse/i.test(navigator.userAgent)) {
                        return;
                    }
                    
                    const element = event.target.closest('a')

                    if(!element) {
                        return
                    }

                    const isPro = true
                    if(!isPro) {
                        return
                    }

                    // Don't track left clicks with this event. The click event is used for that.
                    if(event.button === 0) {
                        return
                    }

                    track(element)
                })
                document.addEventListener('click', function (event) {
                                        if (navigator.webdriver || /bot|crawler|spider|crawling|semrushbot|chrome-lighthouse/i.test(navigator.userAgent)) {
                        return;
                    }
                    
                    const element = event.target.closest('a, button')

                    if(!element) {
                        return
                    }

                    const isPro = true
                    if(!isPro) {
                        return
                    }

                    track(element)
                })
                document.addEventListener("DOMContentLoaded", function (e) {
                    if (document.hasOwnProperty("visibilityState") && document.visibilityState === "prerender") {
                        return;
                    }

                                            if (navigator.webdriver || /bot|crawler|spider|crawling|semrushbot|chrome-lighthouse/i.test(navigator.userAgent)) {
                            return;
                        }
                    
                    let referrer_url = null;

                    if (typeof document.referrer === 'string' && document.referrer.length > 0) {
                        referrer_url = document.referrer;
                    }

                    const params = location.search.slice(1).split('&').reduce((acc, s) => {
                        const [k, v] = s.split('=');
                        return Object.assign(acc, {[k]: v});
                    }, {});

                    const url = "https://boomn-dev.instawp.xyz/mva/wp-json/iawp/search";
                    const body = {
                        referrer_url,
                        utm_source: params.utm_source,
                        utm_medium: params.utm_medium,
                        utm_campaign: params.utm_campaign,
                        utm_term: params.utm_term,
                        utm_content: params.utm_content,
                        gclid: params.gclid,
                        ...{"payload":{"resource":"singular","singular_id":424,"page":1},"signature":"e4637746789665f6f955fcfda0dc8ca0"}                    };

                    if (navigator.sendBeacon) {
                        let blob = new Blob([JSON.stringify(body)], {
                            type: "application/json"
                        });
                        navigator.sendBeacon(url, blob);
                    } else {
                        const xhr = new XMLHttpRequest();
                        xhr.open("POST", url, true);
                        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
                        xhr.send(JSON.stringify(body))
                    }
                });
            })();
        

/* --- Inline Script --- */


/* --- Inline Script --- */
document.addEventListener('DOMContentLoaded', function(){     if (!window.dlsFrontend) {
        window.dlsFrontend = {}
    }

    window.dlsFrontend.data = {"homeUrl":"https:\/\/boomn-dev.instawp.xyz\/mva","ajaxUrl":"https:\/\/boomn-dev.instawp.xyz\/mva\/wp-admin\/admin-ajax.php","elementsPluginUrl":"https:\/\/boomn-dev.instawp.xyz\/mva\/wp-content\/plugins\/dls\/subplugins\/dls-elements\/","BASE_BREAKPOINT_ID":"breakpoint_base","breakpoints":[{"id":"breakpoint_base","label":"Desktop","defaultPreviewWidth":"100%"},{"id":"breakpoint_tablet_landscape","label":"Tablet Landscape","defaultPreviewWidth":1024,"maxWidth":1119},{"id":"breakpoint_tablet_portrait","label":"Tablet Portrait","defaultPreviewWidth":768,"maxWidth":1023},{"id":"breakpoint_phone_landscape","label":"Phone Landscape","defaultPreviewWidth":480,"maxWidth":767},{"id":"breakpoint_phone_portrait","label":"Phone Portrait","defaultPreviewWidth":400,"maxWidth":479}],"subscriptionMode":"pro"} }) 

